import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CpfPipe } from './cpf/cpf.pipe';
import { DateTimePipe } from './date/date-time.pipe';
import { TelefonePipe } from './telefone/telefone.pipe';
import { CnpjPipe } from './cnpj/cnpj.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    CpfPipe,
    DateTimePipe,
    TelefonePipe,
    CnpjPipe
  ],
  exports: [
    CpfPipe,
    DateTimePipe,
    TelefonePipe,
    CnpjPipe
  ]
})
export class PipesModule { }
